var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M16.3447 3.99322C15.8876 3.53611 15.05 3.53611 14.5928 3.99322L13.5483 5.0378L15.2178 6.70737C15.24 6.72957 15.2605 6.75282 15.2794 6.77695L16.3483 5.74139C16.8018 5.28348 16.8006 4.44911 16.3447 3.99322ZM6.01872 12.5674L12.4876 6.09846L14.1572 7.76803C14.1736 7.78449 14.1907 7.80003 14.2082 7.81464L7.53793 14.2765L6.01872 12.5674ZM4.97598 13.6521L3.86645 16.241L6.45536 15.3164L4.97598 13.6521ZM7.965 15.9512L7.39686 16.5016C7.31999 16.576 7.22807 16.6332 7.12727 16.6692L2.75227 18.2317C2.47141 18.332 2.1578 18.2564 1.95354 18.0391C1.74928 17.8218 1.69318 17.5041 1.81066 17.23L3.68566 12.855C3.72324 12.7673 3.77722 12.6875 3.84469 12.6201L13.5322 2.93256C14.5751 1.88967 16.3625 1.88967 17.4053 2.93256C18.4482 3.97545 18.4482 5.76283 17.4053 6.80573L17.3969 6.81414L17.3969 6.81408L8.07397 15.8456C8.05097 15.8729 8.02573 15.8989 7.99828 15.9233C7.98739 15.9329 7.97629 15.9423 7.965 15.9512Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }